import {
  ACTIVATION_REQUEST,
  ACTIVATION_REQUEST_FAILURE,
  ACTIVATION_REQUEST_SUCCESS,
  ADD_ACTIVATION_FIELD_ERROR,
  CHANGE_ACTIVATION_FORM_FIELD,
  CLEAR_ACTIVATION_FIELD_ERROR,
} from './actions'

export interface ActivationState {
  formData: {
    password: string
    password2: string
  }
  errors: Record<string, string | undefined>
  loading: boolean
}

export const initialState = (): ActivationState => ({
  formData: {
    password: '',
    password2: '',
  },
  errors: {},
  loading: false,
})

interface ChangeFieldAction {
  type: string
  payload: { key: string; value: string }
}

interface FailureAction {
  type: string
  errors: Record<string, string | undefined>
}

interface FieldErrorAction {
  type: string
  payload: { field: string; error?: string }
}

type ActivationAction = ChangeFieldAction | FailureAction | FieldErrorAction

export default function reducer(
  state: ActivationState = initialState(),
  action: ActivationAction,
): ActivationState {
  switch (action.type) {
    case CHANGE_ACTIVATION_FORM_FIELD: {
      const { key, value } = (action as ChangeFieldAction).payload
      return {
        ...state,
        formData: {
          ...state.formData,
          [key]: value,
        },
      }
    }

    case ACTIVATION_REQUEST:
      return {
        ...state,
        loading: true,
        errors: {},
      }

    case ACTIVATION_REQUEST_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case ACTIVATION_REQUEST_FAILURE:
      return {
        ...state,
        loading: false,
        errors: (action as FailureAction).errors,
      }

    case ADD_ACTIVATION_FIELD_ERROR: {
      const { field, error } = (action as FieldErrorAction).payload as {
        field: string
        error: string
      }
      return {
        ...state,
        errors: {
          ...state.errors,
          [field]: error,
        },
      }
    }

    case CLEAR_ACTIVATION_FIELD_ERROR: {
      const { field } = (action as FieldErrorAction).payload
      return {
        ...state,
        errors: {
          ...state.errors,
          [field]: undefined,
        },
      }
    }
    default:
      return state
  }
}
